import createTableSelectionStore from "ds/components/Table/store/useTableSelectionStore";

const useStacksTableSelectionStore = createTableSelectionStore();

export default useStacksTableSelectionStore;
